import { render, staticRenderFns } from "./admin-manage.vue?vue&type=template&id=1ed9e57e&scoped=true"
import script from "./admin-manage.vue?vue&type=script&lang=js"
export * from "./admin-manage.vue?vue&type=script&lang=js"
import style0 from "./admin-manage.vue?vue&type=style&index=0&id=1ed9e57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9e57e",
  null
  
)

export default component.exports